import React, { useEffect, useRef, useState } from 'react';
import {DistributionCentersScreen} from '../screens/distribution-centers/ui/screens/DistributionCentersScreen';
export default function DistributionCentersConfiguration() {

    return (
        <div>
           <DistributionCentersScreen></DistributionCentersScreen>
        </div>
    );
}